/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable camelcase */
import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEqual, cloneDeep } from 'lodash';
import PropTypes from 'prop-types';

import useWindowDimensions from '../../../../shared/custom-hooks/useWindowDimension';
import { FormContext } from '../../../shared/contexts/form-context';
import { setUserInputOnCtrl } from '../../../form/reducer/form';
import { ControlPropType } from '../../ctrl_proptype';
import { controlValidate } from '../../../form/utils';
import { getNumbers } from '../../../../shared/utils';
import {
  MatrixRatingWrapper,
  MatrixRatingTable,
  InputRadio,
  MatrixData,
  MatrixHead,
  TableHead,
  TableRow,
} from './matrix_rating.styled';

const MatrixTable = ({ ctrl, setCtrlValidationError }) => {
  const { row_headers, column_headers, rating_type, no_table_border, stacked, unstackable } = ctrl.props;
  const { inPreviewPage: previewMode, previewViewPort } = useSelector((state) => state.builder.present);
  const [matrixValues, setMatrixValues] = useState(ctrl.value ? [...ctrl.value] : []);
  const isBuilderPreviewMobile = previewMode && previewViewPort === 'mobile';
  const { userCustomTexts } = useSelector((state) => state.form);
  const { inForm, currentPageNo } = useContext(FormContext);
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const isMobileView = width <= 768 || isBuilderPreviewMobile;

  const saveUpdatedCtrl = (newValue, isValid) => {
    dispatch(
      setUserInputOnCtrl({
        isValid,
        newValue,
        property: 'value',
        page: currentPageNo - 1,
        ctrlId: ctrl.internal_id,
      })
    );
  };

  const populateMatrix = () => {
    const clicked = {};

    if (inForm) {
      const clickedColumnHeaders = [];

      const hasValue = ctrl.value?.length > 0;

      if (hasValue) {
        ctrl.value.forEach((value) => {
          const val = value?.split(': ')?.pop();
          if (val) {
            clickedColumnHeaders.push(val);
          }
        });
      }

      if (hasValue && clickedColumnHeaders.length > 0) {
        ctrl.value.forEach((_, index) => {
          clicked[index + 1] = [index + 1, column_headers.indexOf(clickedColumnHeaders[index]) + 1];
        });
      }
    }

    return clicked;
  };

  const emptyOrNot = (row, col) => {
    const clicked = populateMatrix();

    if (isEqual(clicked[row], [row, col])) {
      return rating_type === 'star' ? 'yellow' : 'black';
    }

    return 'empty';
  };

  const handleRatingClick = (row, col) => {
    if (!inForm) return;

    let newAnswer;
    const newClickedValue = column_headers[col - 1];
    const prevClickedValue = matrixValues[row - 1]?.split(': ')?.pop();

    if (newClickedValue === prevClickedValue) {
      newAnswer = `${row_headers[row - 1]}: undefined`;
    } else {
      newAnswer = `${row_headers[row - 1]}: ${newClickedValue}`;
    }

    const updatedValues = matrixValues.map((v, idx) => (idx === row - 1 ? newAnswer : v));

    setMatrixValues(updatedValues);

    if (!isEqual(ctrl.value, updatedValues)) {
      const newCtrl = cloneDeep(ctrl);
      newCtrl.value = updatedValues;
      const { requiredOk } = controlValidate(newCtrl, userCustomTexts, setCtrlValidationError);
      saveUpdatedCtrl(updatedValues, requiredOk);
    }
  };

  return (
    <MatrixRatingWrapper id={`fpl-${ctrl.internal_id}`}>
      <MatrixRatingTable noBorder={no_table_border} isMobileView={isMobileView}>
        <TableHead stacked={stacked} unstackable={unstackable} isMobileView={isMobileView}>
          <TableRow stacked={stacked} unstackable={unstackable} noBorder={no_table_border} isMobileView={isMobileView}>
            <MatrixHead isHead stacked={stacked} unstackable={unstackable} noBorder={no_table_border} />
            {getNumbers(column_headers.length).map((no) => (
              <MatrixHead key={no} stacked={stacked} unstackable={unstackable} noBorder={no_table_border}>
                {column_headers[no - 1]}
              </MatrixHead>
            ))}
          </TableRow>
        </TableHead>

        <tbody>
          {getNumbers(row_headers.length).map((row) => (
            <TableRow
              key={row}
              stacked={stacked}
              unstackable={unstackable}
              noBorder={no_table_border}
              isMobileView={isMobileView}>
              <MatrixData
                isQuestion
                stacked={stacked}
                unstackable={unstackable}
                noBorder={no_table_border}
                isMobileView={isMobileView}>
                {row_headers[row - 1]}
              </MatrixData>
              {getNumbers(column_headers.length).map((col) => (
                <MatrixData
                  key={col}
                  className="rating"
                  stacked={stacked}
                  unstackable={unstackable}
                  noBorder={no_table_border}
                  isMobileView={isMobileView}
                  data-question={column_headers[col - 1]}>
                  {rating_type === 'star' && (
                    <i
                      tabIndex="0"
                      onClick={() => handleRatingClick(row, col)}
                      className={`ui star icon ${emptyOrNot(row, col)}`}
                    />
                  )}
                  {rating_type === 'radio' && (
                    <label tabIndex="0">
                      <InputRadio
                        type="radio"
                        checked={emptyOrNot(row, col) === 'black'}
                        onClick={() => handleRatingClick(row, col)}
                        onChange={() => handleRatingClick(row, col)}
                      />
                    </label>
                  )}
                </MatrixData>
              ))}
            </TableRow>
          ))}
        </tbody>
      </MatrixRatingTable>
    </MatrixRatingWrapper>
  );
};

MatrixTable.defaultProps = {
  setCtrlValidationError: () => null,
};

MatrixTable.propTypes = {
  setCtrlValidationError: PropTypes.func,
  ctrl: PropTypes.shape(ControlPropType).isRequired,
};
export default MatrixTable;
